import type { ImageProps } from '@archipro-design/aria';
import { Image, useStyles } from '@archipro-design/aria';
import { AnimatePresence, motion } from 'framer-motion';
import * as S from './PreviewImage.style';
import { Animation } from '@fluentui/react-northstar';
import { Loader } from '@archipro-design/icons';
import React from 'react';
import cx from 'classnames';

interface PreviewImageProps {
    show: boolean;
    imageUrl?: string;
    imageProps: Omit<ImageProps, 'src'>;
}

const PreviewImage = ({ show, imageUrl, imageProps }: PreviewImageProps) => {
    const { css } = useStyles();
    return (
        <AnimatePresence>
            {!show && imageUrl && (
                <motion.div
                    // The image's own corner, if it has one, so the loading
                    // wash is clipped to the picture rather than its box.
                    className={cx(
                        css(S.PreviewImageContainer),
                        imageProps.className,
                    )}
                    initial={{ opacity: 1 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{
                        duration: 0.01,
                    }}
                >
                    <Image {...imageProps} src={imageUrl} alt={''} />
                    <div className={css(S.Loading)}>
                        <Animation name="rotateUltraSlow">
                            <Loader size="2x" />
                        </Animation>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default PreviewImage;
